<template>
  <Popover class="relative">
    <Float auto-placement portal :offset="10">
      <PopoverButton
        class="rounded border border-gray-300 px-2 py-1 leading-none"
        :class="{ 'bg-gray-200': editor.isActive('link') }"
        :title="$t('button.insert_link')"
        :disabled="!canEditLink"
        @click.stop="loadCurrentHref"
      >
        <FontAwesomeIcon :icon="['far', 'link']" size="sm" />
      </PopoverButton>
      <PopoverPanel
        v-slot="{ close }"
        class="z-100 w-72 rounded-lg bg-white p-3 shadow-xl ring-1 ring-black/5"
        @click.stop
      >
        <div class="flex flex-col gap-3">
          <BaseInput
            v-model="href"
            :name="inputName"
            :label="$t('attributes.link_url')"
            @keydown.enter.prevent="applyLink(close)"
          />
          <div class="flex justify-end gap-2">
            <BaseButton
              v-if="editor.isActive('link')"
              :title="$t('button.remove_link')"
              size="small"
              color="danger"
              @click="removeLink(close)"
            />
            <BaseButton
              :title="$t('button.apply')"
              size="small"
              color="primary"
              @click="applyLink(close)"
            />
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseInput from '@c/addf-package/components/BaseInput/BaseInput.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { normalizeLinkHref } from '../linkHref'

/** Gives every popover input its own name, so several editors on one page do not collide. */
let instanceCount = 0

export default {
  name: 'WysiwygLinkPopover',
  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    Float,
    FontAwesomeIcon,
    BaseInput,
    BaseButton
  },
  props: {
    editor: {
      type: Object,
      required: true
    }
  },
  data() {
    instanceCount += 1

    return {
      href: '',
      inputName: `link_url_${instanceCount}`
    }
  },
  computed: {
    canEditLink() {
      return this.editor.isActive('link') || !this.editor.state.selection.empty
    }
  },
  methods: {
    loadCurrentHref() {
      this.href = this.editor.getAttributes('link').href ?? ''
    },
    applyLink(close) {
      const href = normalizeLinkHref(this.href)
      if (href === null) {
        this.$h.toastDanger(
          this.$t('validation.url').replace(
            ':attribute',
            this.$t('attributes.link_url')
          )
        )
        return
      }

      this.editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href, target: '_blank', rel: 'noopener noreferrer' })
        .run()
      close()
    },
    removeLink(close) {
      this.editor.chain().focus().extendMarkRange('link').unsetLink().run()
      close()
    }
  }
}
</script>
